import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { RequestFeedback } from '../../presentationalComponents/RequestFeedback/RequestFeedback';
import { resetFeedback, updateFeedback } from '../../reduxUpdater/actions/requestFeedbackActions';
import { dispatchSubmitFeedback } from '../../reduxUpdater/dispatchers/contactUsDispatchers';
import { allFeedbackDetailsSelector, feedbackCommentSelector, feedbackCommentMaxLengthSelector, feedbackIssueResolvedSelector, feedbackSubmitStatusSelector, isProcessingSelector, issueReolvedChoiceGroupKeySelector, ratingSelector, ratingTextSelector, surveyCheckBoxCategoriesSelector } from '../../reduxUpdater/selectors/requestFeedbackSelectors';
import { getRequestFeedbackStyles } from '../../styles/requestFeedbackStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    feedbackCommentMaxLength: feedbackCommentMaxLengthSelector(state),
    feebackSubmitStatus: feedbackSubmitStatusSelector(state, _ownProps.requestId),
    isProcessing: isProcessingSelector(state, _ownProps.requestId),
    rating: ratingSelector(state, _ownProps.requestId),
    ratingText: ratingTextSelector(state, _ownProps.requestId),
    allFeedbackDetails: allFeedbackDetailsSelector(state, _ownProps.requestId),
    surveyCheckBoxes: surveyCheckBoxCategoriesSelector(state, _ownProps.requestId),
    feedbackComment: feedbackCommentSelector(state, _ownProps.requestId),
    feedbackIssueResolved: feedbackIssueResolvedSelector(state, _ownProps.requestId),
    choiceGroupSelectedKey: issueReolvedChoiceGroupKeySelector(state, _ownProps.requestId),
  };
};

const mapDispatchToProps = {
  dispatchSubmitFeedback,
  updateFeedback,
  resetFeedback,
};

export const RequestFeedbackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RequestFeedback, getRequestFeedbackStyles));
